import { Spinner, SpinnerSize, Tab } from "@blueprintjs/core";
import { useApiEffect } from "nsitools-react";
import * as React from "react";
import { useHistory, useParams } from "react-router";

import { EmailApi } from "../../../../api";
import { BackButton, PageBase, ProtectedTabs } from "../../../../components";
import { ERoutes } from "../../../../ERoutes";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { EmailDetailPage } from "./EmailDetailPage";

export interface IEmailItemPageProps {}

export const EmailItemPage: React.FunctionComponent<IEmailItemPageProps> = (props) => {
  const { t } = useTl();
  const { id, tab, state = "edit" } = useParams<{ id: string; tab: string; state: string }>();
  const emailId = React.useMemo(() => +id, [id]);
  const history = useHistory();
  const emailApi = useApiService(EmailApi);
  const [displayName, loading] = useApiEffect(() => emailApi.getDisplayName(emailId), [emailId]);

  return (
    <PageBase
      breadCrumbs={[
        { text: t(ETLCodes.Emails), route: ERoutes.email },
        { text: emailId > 0 ? loading ? <Spinner size={SpinnerSize.SMALL} /> : displayName : t(ETLCodes.New) },
      ]}
    >
      <ProtectedTabs
        id="EmailTab"
        onChange={(newTabId) => history.push(`${ERoutes.email}/${id}/${newTabId}/${state}`)}
        selectedTabId={tab}
        renderActiveTabPanelOnly
      >
        <BackButton backRoute={ERoutes.email} />
        <Tab
          id="detail"
          title={t(ETLCodes.Detail)}
          panel={<EmailDetailPage mailTemplateId={emailId} editMode={state === "edit"} />}
        />
      </ProtectedTabs>
    </PageBase>
  );
};
